import { FormGroup } from "@mui/material";
import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { FormikTextInput } from "@thrivetribe/mvf.ui.atoms.formik-text-input";
import {
  OnboardingPage,
  OnboardingPageBody,
  OnboardingPageContent,
  OnboardingPageCopy,
} from "@thrivetribe/mvf.ui.organisms.onboarding-page";
import { Form as FormikForm, Formik } from "formik";
import { sendForgottenPasswordEmail } from "helpers/sendForgotPasswordEmail";
import React from "react";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";
import "./ForgottenPassword.scss";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { update_forgotten_password_email } from "redux/forgottenPasswordSlice";
import { Gtag } from "configs/ReactGa";
import { ImagesUrl } from "configs/EnvironmentConfig";

type FormValueTypes = {
  email: string;
};

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email("Please enter a valid email address")
    .required("We need your email address to send you instructions"),
});
export const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialValues: FormValueTypes = {
    email: "",
  };

  const handleSubmit = async (values: FormValueTypes) => {
    dispatch(update_forgotten_password_email(values));
    try {
      await sendForgottenPasswordEmail(values);
      Gtag("event", "password_reset_request", {
        event_category: "password reset",
      });
      navigate("/password-requested");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="reset-password">
      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validateOnChange={true}
        validationSchema={validationSchema}
      >
        <FormikForm>
          <Helmet>
            <title>Reset Password - MAN v FAT</title>
          </Helmet>
          <OnboardingPage hideProfile hideSubnav image={`${ImagesUrl}/football.webp`} user={""}>
            <OnboardingPageContent centralizeContent>
              <OnboardingPageBody>
                <a href="/" className="back-button">
                  <ButtonArrow /> Back
                </a>
                <OnboardingPageCopy>
                  <h1>Reset Password</h1>
                  <p>Enter the email address you gave us when you signed up.</p>
                </OnboardingPageCopy>
                <FormGroup className="onboarding-page__content--group">
                  <FormikTextInput id="email" name="email" label="Email address" />
                  <p className="sign-in-prompt">
                    Already have a password? <Link to={"/"}> Sign in </Link>{" "}
                  </p>
                </FormGroup>

                <Button type="submit" onClick={() => {}} variant="primary" color="primary">
                  Send instructions
                  <ButtonArrow />
                </Button>
              </OnboardingPageBody>
            </OnboardingPageContent>
          </OnboardingPage>
        </FormikForm>
      </Formik>
    </div>
  );
};
